import { schema } from 'normalizr';

export const discountDefSchema = new schema.Entity('discountDefs');
